import React from 'react';
import { GoogleReCaptchaProvider } from 'react-google-recaptcha-v3';

import { useState } from '../../../state/store';
import { Page } from '../../../state/types';
import ContactUs from './ContactUs';

const ContactUsWithRecaptcha: React.FC = () => {
  const { page, recaptchaKey } = useState('page', 'recaptchaKey');

  if (page !== Page.ContactUs) {
    return null;
  }

  return (
    <GoogleReCaptchaProvider reCaptchaKey={recaptchaKey}>
      <ContactUs />
    </GoogleReCaptchaProvider>
  );
};

export default ContactUsWithRecaptcha;
